// src/redux/slices/modalSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ModalState {
  isModifierModalOpen: boolean;
  isRepeatCustomisationModalOpen: boolean;
  isDeleteVariantModalOpen: boolean;
  selectedCartItem: any | null;
  currentMenuItem: any | null;
  editMode: boolean;
  deleteVariants: any[];
}

const initialState: ModalState = {
  isModifierModalOpen: false,
  isRepeatCustomisationModalOpen: false,
  isDeleteVariantModalOpen: false,
  selectedCartItem: null,
  currentMenuItem: null,
  editMode: false,
  deleteVariants: [],
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModifierModal: (state, action: PayloadAction<{ item: any; editMode?: boolean }>) => {
      state.isModifierModalOpen = true;
      state.currentMenuItem = action.payload.item;
      state.editMode = action.payload.editMode || false;
    },
    closeModifierModal: (state) => {
      state.isModifierModalOpen = false;
      state.currentMenuItem = null;
      state.editMode = false;
      state.selectedCartItem = null;
    },
    openRepeatCustomisationModal: (
      state,
      action: PayloadAction<{ cartItem: any; menuItem: any }>
    ) => {
      state.isRepeatCustomisationModalOpen = true;
      state.selectedCartItem = action.payload.cartItem;
      state.currentMenuItem = action.payload.menuItem;
    },
    closeRepeatCustomisationModal: (state) => {
      state.isRepeatCustomisationModalOpen = false;
      state.selectedCartItem = null;
      state.currentMenuItem = null;
    },
    openDeleteVariantModal: (
      state,
      action: PayloadAction<{ variants: any[]; menuItem: any }>
    ) => {
      state.isDeleteVariantModalOpen = true;
      state.deleteVariants = action.payload.variants;
      state.currentMenuItem = action.payload.menuItem;
    },
    closeDeleteVariantModal: (state) => {
      state.isDeleteVariantModalOpen = false;
      state.deleteVariants = [];
      state.currentMenuItem = null;
    },
    setSelectedCartItem: (state, action: PayloadAction<any>) => {
      state.selectedCartItem = action.payload;
    },
  },
});

export const {
  openModifierModal,
  closeModifierModal,
  openRepeatCustomisationModal,
  closeRepeatCustomisationModal,
  openDeleteVariantModal,
  closeDeleteVariantModal,
  setSelectedCartItem,
} = modalSlice.actions;

export default modalSlice.reducer;
